var map = {
	"./Pattern.svg": 1,
	"./circle-arrow.svg": 2,
	"./envelope.svg": 3,
	"./facebook.svg": 4,
	"./mail.svg": 5,
	"./next.svg": 6,
	"./phone.svg": 7,
	"./prev.svg": 8,
	"./search.svg": 9,
	"./twitter.svg": 10,
	"./vimeo.svg": 11,
	"./xing.svg": 12,
	"./youtube.svg": 13
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 0;